(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('LangueDeleteController',LangueDeleteController);

    LangueDeleteController.$inject = ['$uibModalInstance', 'entity', 'Langue'];

    function LangueDeleteController($uibModalInstance, entity, Langue) {
        var vm = this;

        vm.langue = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Langue.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
